import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { CostAccountingTypeDialogComponent } from './cost-accounting-type-dialog.component';

export * from './cost-accounting-type-dialog.component';
@NgModule({
    declarations: [ CostAccountingTypeDialogComponent ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        TranslateModule,
        GenericInputModule,
    ],
})
export class CostAccountingTypeDialogModule {
}
